var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex justify-between px-5 py-3"},[_c('JadeDisplayItem',{attrs:{"label":_vm.$t('amount'),"value":_vm.data.value,"support":_vm.data.id}}),_c('JadeDisplayItem',{attrs:{"alignment":"right","label":_vm.$t('status'),"value":_vm.data.status}})],1),_c('JadeDivider',{attrs:{"size":"medium"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }